var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PTopMenuTag',{attrs:{"icon-name":"link","label":"リンクをコピー"},on:{"click":_vm.copyLink}})}
var staticRenderFns = []

export { render, staticRenderFns }